import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CoursePlayer from "./pages/student/CoursePlayer";
import StudentLogin from "./pages/student/StudentLogin";
import StudentRegister from "./pages/student/StudentRegister";
import LeaderBoard from "./pages/student/LeaderBoard";
import StudentQuiz from "./pages/student/StudentQuiz";
import Dashboard from "./pages/admin/Dashboard";
import Assignment from "./pages/admin/assignment/Assignment";
import AssignmentMark from "./pages/admin/assignment/AssignmentMark";
import Login from "./pages/admin/Login";
import Quizzes from "./pages/admin/quiz/Quizzes";
import Videos from "./pages/admin/videos/Videos";
import useAuthCheck from "./hooks/useAuthCheck";
import StudentRoute from "./components/auth/StudentRoute";
import PublicRoute from "./components/auth/PublicRoute";
import AdminRoute from "./components/auth/AdminRoute";
import AddVideo from "./pages/admin/videos/AddVideo";
import EditVideo from "./pages/admin/videos/EditVideo";
import AddQuiz from "./pages/admin/quiz/AddQuiz";
import EditQuiz from "./pages/admin/quiz/EditQuiz";
import AddAssignment from "./pages/admin/assignment/AddAssignment";
import EditAssignment from "./pages/admin/assignment/EditAssignment";
function App() {
  const authChecked = useAuthCheck();

  return (
    <div className="App">
      {!authChecked ? (
        <span>Loading...</span>
      ) : (
        <Router>
          <Routes>
            {/* Student Section  */}

            <Route
              path="/"
              element={
                <StudentRoute>
                  <CoursePlayer />
                </StudentRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <StudentLogin />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <StudentRegister />
                </PublicRoute>
              }
            />
            <Route
              path="/leaderboard"
              element={
                <StudentRoute>
                  <LeaderBoard />
                </StudentRoute>
              }
            />
            <Route
              path="/quiz/:video_id"
              element={
                <StudentRoute>
                  <StudentQuiz />
                </StudentRoute>
              }
            />
            {/* Admin Section  */}
            <Route
              path="/admin/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <AdminRoute>
                  <Dashboard />
                </AdminRoute>
              }
            />
            {/* Assignemnt  */}
            <Route
              path="/admin/assignment"
              element={
                <AdminRoute>
                  <Assignment />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/assignment/add"
              element={
                <AdminRoute>
                  <AddAssignment />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/assignment/edit/:id"
              element={
                <AdminRoute>
                  <EditAssignment />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/assignment-mark"
              element={
                <AdminRoute>
                  <AssignmentMark />
                </AdminRoute>
              }
            />
            {/* quizzes */}
            <Route
              path="/admin/quizzes"
              element={
                <AdminRoute>
                  <Quizzes />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/quizzes/add"
              element={
                <AdminRoute>
                  <AddQuiz />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/quizzes/edit/:id"
              element={
                <AdminRoute>
                  <EditQuiz />
                </AdminRoute>
              }
            />
            {/* videos */}
            <Route
              path="/admin/videos"
              element={
                <AdminRoute>
                  <Videos />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/videos/add"
              element={
                <AdminRoute>
                  <AddVideo />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/videos/edit/:id"
              element={
                <AdminRoute>
                  <EditVideo />
                </AdminRoute>
              }
            />
          </Routes>
        </Router>
      )}
    </div>
  );
}

export default App;
